import { FC } from "react"
import NewBeltModal from "../NewBeltModal/NewBeltModal"
import { NewsBarHandler } from "../NewsBarHandler/NewsBarHandler"
import { WelcomeModalRouter } from "../WelcomeModal/WelcomeModalRouter"

type MessagePortalProps = {
  isNewsBarActive: boolean
  displayNewBeltModal: boolean
  setDisplayNewBeltModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const MessagePortal: FC<MessagePortalProps> = ({
  isNewsBarActive,
  displayNewBeltModal,
  setDisplayNewBeltModal,
}) => {
  return (
    <>
      {isNewsBarActive && <NewsBarHandler />}
      {displayNewBeltModal && <NewBeltModal close={() => setDisplayNewBeltModal(false)} />}
      <WelcomeModalRouter />
    </>
  )
}
